import { HStack, VStack, Text, Image, Box, Tag } from '@chakra-ui/react';
import React from 'react';
import { formatPrice } from '../utils/helpers';

const hexToColorName = (hex) => {
  const colorMap = {
    "#ffffff": "Blanc",
    "#000000": "Noir",
    "#ff0000": "Rouge",
    "#00ff00": "Vert",
    "#0000ff": "Bleu",
    "#ffff00": "Jaune",
    "#ff6600": "Orange",
    "#800080": "Violet",
    "#ffc0cb": "Rose",
    "#808080": "Gris",
    "#c0c0c0": "Argent",
    "#a52a2a": "Marron",
    "#ff9900": "Orange",
    "#996633": "Marron",
    "#33cc33": "Vert",
    "#339933": "Vert foncé",
    "#9933ff": "Violet",
    "#cc33cc": "Magenta",
    "#6666ff": "Bleu clair",
    "#0099ff": "Bleu ciel",
    "#00cccc": "Cyan",
    "#333333": "Noir charbon",
    "#ffcc00": "Or",
    "#fff0db": "Beige",
    "#800000": "Marron Foncé",
    "#f5f5dc": "Beige",
    "#faebd7": "Antique White",
    "#d2b48c": "Tan",
    "#f4a460": "Sandy Brown",
    "#deb887": "Burly Wood",
    "#ffe4c4": "Bisque",
  };
  return colorMap[(hex || "").toLowerCase()] || null;
};

const isHex = (str) => /^#[0-9A-F]{3,6}$/i.test(str);

const getDisplayColor = (rawColor, colorName) => {
  if (colorName && !isHex(colorName)) {
    return colorName;
  }
  
  if (isHex(rawColor)) {
    const mapped = hexToColorName(rawColor);
    if (mapped) return mapped;
  }

  if (!rawColor) {
    return 'N/A';
  }

  return String(rawColor).trim();
};

const isWhiteLikeColor = (rawColor) => {
  if (!rawColor) {
    return false;
  }

  const normalized = String(rawColor).trim().toLowerCase();
  return normalized === 'white' || normalized === '#fff' || normalized === '#ffffff';
};

function OrderItemsList({ orderItems }) {
  return (
    <VStack alignItems='flex-start' spacing='4'>
      {orderItems.map((item, index) => {
        const { name, price, quantity, image, color, colorName, size } = item;
        const colorLabel = getDisplayColor(color, colorName);
        const whiteColor = isWhiteLikeColor(color);

        return (
          <HStack key={index} alignItems='flex-start' spacing='5'>
            <Image
              src={image}
              boxSize='100px'
              objectFit='cover'
              borderRadius='lg'
            />
            <VStack alignItems='flex-start'>
              <HStack spacing='3'>
                <Text as='b'>{name}</Text>
                <HStack spacing='2'>
                  <Box
                    bg={color || 'gray.200'}
                    w='22px'
                    h='22px'
                    borderRadius='6px'
                    border='1px solid'
                    borderColor={whiteColor ? 'gray.500' : 'gray.300'}
                    boxShadow='sm'
                  />
                  <Tag
                    size='sm'
                    variant='subtle'
                    colorScheme={whiteColor ? 'gray' : 'blue'}
                    textTransform='capitalize'
                  >
                    {colorLabel}
                  </Tag>
                </HStack>
                <Tag
                  variant='outline'
                  colorScheme='brown'
                  size='sm'
                  textTransform='uppercase'
                >
                  {size}
                </Tag>
              </HStack>
              <Text color='green' fontWeight='bold'>{formatPrice(price)}</Text>
              <HStack spacing='2'>
                <Text as='b' color='gray.600'>Quantity:</Text>
                <Tag 
                  colorScheme='blue' 
                  size='lg' 
                  fontWeight='bold'
                  fontSize='md'
                >
                  {quantity}
                </Tag>
              </HStack>
            </VStack>
          </HStack>
        );
      })}
    </VStack>
  );
}

export default OrderItemsList;
